export {
	BOT_SETUP_GUIDE_URL,
	type GrandSlamResource as ResourceGuideItem,
	type GrandSlamResourceIcon as ResourceGuideIcon,
} from './prestart.constants';

export const RESOURCES_GUIDE_TITLE = 'Grand Slam Challenge Guide';
export const RESOURCES_GUIDE_INTRO =
	"Everything you need on what's up for grabs, how points are scored, how the competition works, and how to set up your forecasting bot.";

export const RESOURCES_COACHMARK_SEEN_KEY_PREFIX = 'probability-event:resources-coachmark-seen';
export const RESOURCES_GUIDE_OPENED_KEY_PREFIX = 'probability-event:resources-guide-opened';
